import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline'

import { clientMedia } from '../../../../Config/Settings';

import { isCharHebrew } from '../../../../utils';

// components

// svgs
import locationBlueSVG from '../../../inlineSVGs/locationBlueSVG';

// styles
import './Location.css';

const Location = ({ address, wrapperStyle, musicType }) => {

    const getRevenueName = () => {
        // TODO: extract real hour later
        return address && address.revenueName;
    };

    const getImageUrl = () => {
        return `url(${clientMedia()}/img/categoriesNeon/${musicType}.svg`
    };

    const formatAddress = () => {
        // example: ',53 Kibutz Galuiot, Tel Aviv'

        // city: "Tel Aviv-Yafo"
        // country: "Israel"
        // position: {lat: 32.0885, lng: 34.7693}
        // state: "Tel Aviv District"
        // street: "11 Ibn Gabirol Street"

        if (!address) return '';

        if (address.street && address.city) {
            if (isCharHebrew(address.street) || isCharHebrew(address.city)) {
                return `${address.street} ${address.number || ''}, ${address.city}`;
            }

            return `${address.number || ''} ${address.street}, ${address.city}`;
        }

        if (address.street) return `${address.number || ''} ${address.street}`;

        if (address.city) return `${address.city}`;

        return `${address.country ||''}`;

    };

    const isHebrewAddress = () => {
        if (!address) return;
        return isCharHebrew(address.street) || isCharHebrew(address.city)
    };

    return (
        <div className="modal-location-wrapper rtl" style={wrapperStyle}>
            <SVGInline className="location-icon" svg={locationBlueSVG} component="i" fill={'#fff'}/>
            {musicType ?
                <div className="music-type" style={{backgroundImage: getImageUrl()}} />
                : null
            }
            <p className="revenue-name">{getRevenueName()}</p>
            <p className={`address ${isHebrewAddress() ? 'rtl' : ''}`}>{`${formatAddress()}`}</p>
        </div>
    )
};

Location.propTypes = {
    address: PropTypes.object,
    wrapperStyle: PropTypes.object,
    musicType: PropTypes.string
};

export default Location;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/Location/Location.js